import { render, staticRenderFns } from "./ColumnChartCompliance.vue?vue&type=template&id=2c2c8a41"
import script from "./ColumnChartCompliance.vue?vue&type=script&lang=js"
export * from "./ColumnChartCompliance.vue?vue&type=script&lang=js"
import style0 from "./ColumnChartCompliance.vue?vue&type=style&index=0&id=2c2c8a41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports